export default __webpack_public_path__ + "static/media/bruno.921b744a.png";